import { Box } from "@chakra-ui/react";
import React from "react";
import SuccessIcon from "./Icons/SuccessIcon";
import InfoIcon from "./Icons/InfoIcon";
import WarningIcon from "./Icons/WarningIcon";

// CustomToast component for displaying toast messages with different statuses
const CustomToast = ({ message, statusCode, bgColor }) => {
  return (
    <Box
      color="white"
      p={4}
      bg={bgColor ? bgColor : "#39c449"} // Default background color if not provided
      borderRadius={"4px"}
    >
      {/* Render the appropriate icon based on statusCode */}
      {statusCode === "success" ? (
        <SuccessIcon />
      ) : statusCode === "info" ? (
        <InfoIcon />
      ) : statusCode === "warning" ? (
        <WarningIcon />
      ) : null}

      {/* Display the message */}
      {message}
    </Box>
  );
};

export default CustomToast;
